/** Shared journey session-detail layout (is_demo on coach_dashboards). Per-env id in .env.local. */
export const JOURNEY_DASHBOARD_ID = process.env.REACT_APP_JOURNEY_DASHBOARD_ID?.trim() ?? '';

export const JOURNEY_DASHBOARD_DISPLAY_NAME = 'Journey dashboard';

export const JOURNEY_SHARED_DASHBOARD_HINT =
  'Shared journey layout (read-only). Create your own dashboard to customize widgets and sizing.';

export function isJourneySharedDashboard(dashboard: { id: string; isDemo?: boolean }): boolean {
  if (dashboard.isDemo) return true;
  return !!JOURNEY_DASHBOARD_ID && dashboard.id === JOURNEY_DASHBOARD_ID;
}
